import styled from '@emotion/styled';

import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { COLORS3 as COLORS, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const TileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
`;

export const PhotoLinkWrapper = styled.a`
  transition: all 0.2s ease-in-out;
  width: fit-content;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    width: auto;
  }

  ${MEDIA_QUERY.DESKTOP} {
    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const PhotoWrapper = styled.div`
  width: fit-content;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    width: auto;
  }
`;

export const StyledPicture = styled.picture`
  display: block;
  height: 106px;
  width: 150px;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    width: inherit;
  }

  ${MEDIA_QUERY.TABLET} {
    height: 129px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    height: 129px;
  }

  ${MEDIA_QUERY.DESKTOP_LG} {
    height: 198px;
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    height: 248px;
  }
`;

export const StyledImage = styled.img`
  border-radius: 16px;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${SPACING.S16};
  row-gap: ${SPACING.XS};
  white-space: pre-wrap;
  word-wrap: break-word;
  width: 150px;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    width: inherit;
  }

  ${MEDIA_QUERY.TABLET} {
    margin-top: ${SPACING.S24};
  }

  ${MEDIA_QUERY.DESKTOP} {
    margin-top: ${SPACING.S32};
    row-gap: ${SPACING.S16};
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    margin-top: ${SPACING.LG};
  }
`;

export const StyledDescription = styled.p`
  color: ${COLORS.BLACK_075};
  font-size: ${FONT.FONT_SIZE_SMALLER};
  line-height: 150%;
  margin: 0;

  ${MEDIA_QUERY.DESKTOP} {
    font-size: ${FONT.FONT_SIZE_SMALL};
  }

  a {
    color: ${COLORS.BLACK_075};
    text-decoration-color: ${COLORS.BLACK_075};

    &:hover,
    &:focus-visible {
      color: ${COLORS.BLACK_050};
      text-decoration-color: ${COLORS.BLACK_050};
    }
  }
`;

export const StyledHeader = styled(StyledDescription)`
  color: ${COLORS.BLACK_100};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
`;

export const StyledLinkV2 = styled(LinkV2)`
  font-size: ${FONT.FONT_SIZE_SMALLER};
  line-height: 150%;

  ${MEDIA_QUERY.DESKTOP} {
    font-size: ${FONT.FONT_SIZE_SMALL};
  }
`;
